(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["copilot-academy-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function(){

    const $ = window.jQuery;
    if(!$) return;

    const $slider = $('.js-academy-slider');
    if(!$slider.length) return;

    function initSlider(){
      if(window.innerWidth <= 768){
        if(!$slider.hasClass('slick-initialized')){
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            prevArrow: '<button class="copilot-stories__arrow copilot-arrow prev">‹</button>',
            nextArrow: '<button class="copilot-stories__arrow copilot-arrow next">›</button>'
            
          });
        }

      } else {
        if($slider.hasClass('slick-initialized')){
            $slider.slick('unslick');
        }
      }
    }

    initSlider();
    window.addEventListener("resize", initSlider);

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["copilot-centered-video-slider"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
        const lang = document.documentElement.lang || "es";

        // Initialize all video elements inside the slider cards
        document.querySelectorAll(".copilot-centered-card").forEach(card => {
            let src;

            if (lang.startsWith("it")) {
                src = card.dataset.it;
            } else if (lang.startsWith("pt")) {
                src = card.dataset.pt;
            } else {
                src = card.dataset.es;
            }

            const video = card.querySelector("video");
            const btn = card.querySelector(".copilot-centered-card__play");
            const poster = card.querySelector(".copilot-centered-card__poster");

            if (!src || !video) return;

            video.src = src;
            video.muted = true;
            video.playsInline = true;
            video.preload = "metadata";

            function playFullVideo() {
                video.currentTime = 0;
                video.muted = false;
                video.controls = true;
                card.classList.add("playing");

                if (poster) poster.style.opacity = "0";
                if (btn) btn.style.display = "none";

                video.play().catch(() => {});
            }

            function hoverPreviewStart() {
                // Only play preview if item is the active centered item in the slick slider
                const slideParent = card.closest('.slick-slide');
                if (slideParent && !slideParent.classList.contains('slick-center')) return;
                if (window.innerWidth <= 768) return;
                if (card.classList.contains("playing")) return;

                video.muted = true;
                video.controls = false;

                if (poster) poster.style.opacity = "0";
                video.play().catch(() => {});
            }

            function hoverPreviewStop() {
                if (window.innerWidth <= 768) return;
                if (card.classList.contains("playing")) return;

                video.pause();
                video.currentTime = 0;

                if (poster) poster.style.opacity = "";
                if (btn) btn.style.display = "";
            }

            if (btn) {
                btn.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    playFullVideo();
                });
            }

            if (poster) {
                poster.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    playFullVideo();
                });
            }

            card.addEventListener("mouseenter", hoverPreviewStart);
            card.addEventListener("mouseleave", hoverPreviewStop);

            video.addEventListener("ended", function () {
                if (card.classList.contains("playing")) {
                    card.classList.remove("playing");
                    video.controls = false;
                    video.muted = true;
                    video.currentTime = 0;

                    if (poster) poster.style.opacity = "";
                    if (btn) btn.style.display = "";
                }
            });
        });
    });

    document.addEventListener("DOMContentLoaded", function () {
        const slider = document.querySelector(".js-centered-video-slider");
        if (!slider || typeof $ === "undefined" || !$.fn.slick) return;

        const prevArrow = `
            <button type="button" class="slick-prev copilot-arrow-btn" aria-label="Anterior">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>
        `;

        const nextArrow = `
            <button type="button" class="slick-next copilot-arrow-btn" aria-label="Siguiente">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
            </button>
        `;

        // Initialize slick centered slider
        const $slider = $(slider);
        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            centerPadding: '10%',
            arrows: true,
            dots: false,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        centerPadding: '6%'
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '50px'
                    }
                }
            ]
        });

        // Reset video play status when changing slides
        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $slider.find('.copilot-centered-card.playing').each(function() {
                const card = this;
                const video = card.querySelector("video");
                const poster = card.querySelector(".copilot-centered-card__poster");
                const btn = card.querySelector(".copilot-centered-card__play");

                card.classList.remove("playing");
                if (video) {
                    video.pause();
                    video.controls = false;
                    video.muted = true;
                    video.currentTime = 0;
                }
                if (poster) poster.style.opacity = "";
                if (btn) btn.style.display = "";
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["copilot-collections-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {

    if (typeof jQuery === "undefined") return;

    document.querySelectorAll(".copilot-showcase").forEach(function(showcase){

      const sectionId = showcase.id;

      showcase.querySelectorAll(".copilot-badge").forEach(btn => {

        btn.addEventListener("click", function () {

          showcase.querySelectorAll(".copilot-badge")
            .forEach(b => b.classList.remove("is-active"));

          showcase.querySelectorAll(".copilot-products")
            .forEach(p => p.classList.remove("is-visible"));

          this.classList.add("is-active");

          const handle = this.dataset.collection;

          showcase
            .querySelector(`[data-products="${handle}"]`)
            .classList.add("is-visible");

          initSlider(sectionId);

        });

      });

      initSlider(sectionId);

    });

    function initSlider(sectionId){

      if (window.innerWidth > 768) return;

      const showcase = document.getElementById(sectionId);

      showcase.querySelectorAll(".js-showcase-slider").forEach(slider => {

        if (!slider.classList.contains("slick-initialized")) {

          jQuery(slider).slick({
            slidesToShow: 1,
            dots: false,
            arrows: true,
            infinite: true,
            autoplay: true,
            adaptiveHeight: true,
            prevArrow: '<button class="copilot-arrow prev">‹</button>',
            nextArrow: '<button class="copilot-arrow next">›</button>'
          });

        }

      });

    }

    window.addEventListener("resize", function(){

      document.querySelectorAll(".copilot-showcase").forEach(showcase => {
        initSlider(showcase.id);
      });

    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["copilot-logos-marquee"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
        const slider = document.querySelector(".js-logos-slider");
        if (!slider || typeof $ === "undefined" || !$.fn.slick) return;

        if ($(slider).hasClass("slick-initialized")) return;

        $(slider).slick({
            arrows: false,
            dots: false,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            speed: 2000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            pauseOnHover: true,
            pauseOnFocus: false,
            draggable: true,
            swipe: false,
            touchMove: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        speed: 5000
                    }
                }
            ]
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["copilot-real-life-slider"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function(){
        const $ = window.jQuery;
        if(!$) return;

        const $slider = $('.js-real-slider');
        if(!$slider.length) return;

        $slider.slick({
            autoplay: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            centerPadding: '120px',
            adaptiveHeight: false,
            arrows: false,
            dots: true,
            speed: 500,
            responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '80px'
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '60px'
                }
            }
            ]
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["copilot-stages"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {

    function initStagesSlider() {

      const slider = document.querySelector('.js-stages-slider');
      if (!slider) return;

      if (window.innerWidth <= 768) {

        if (!slider.classList.contains('slick-initialized')) {

          jQuery(slider).slick({
            slidesToShow: 1.2,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: false,
            centerMode: false,
            nextArrow: '<button class="copilot-arrow">›</button>',
            prevArrow: '',
          });

        }

      } else {

        if (slider.classList.contains('slick-initialized')) {
          jQuery(slider).slick('unslick');
        }

      }
    }

    initStagesSlider();
    window.addEventListener('resize', initStagesSlider);

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["copilot-video-stories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const lang = document.documentElement.lang || "es";

    document.querySelectorAll(".copilot-video-card").forEach(card => {
        let src;

        if (lang.startsWith("it")) {
            src = card.dataset.it;
        } else if (lang.startsWith("pt")) {
            src = card.dataset.pt;
        } else {
            src = card.dataset.es;
        }

        const video = card.querySelector("video");
        const btn = card.querySelector(".copilot-video-card__play");
        const poster = card.querySelector(".copilot-video-card__poster");

        if (!src) return;

        video.src = src;
        video.muted = true;
        video.playsInline = true;
        video.preload = "metadata";

        function playFullVideo() {
            video.currentTime = 0;
            video.muted = false;
            video.controls = true;
            card.classList.add("playing");

            if (poster) poster.style.display = "none";
            if (btn) btn.style.display = "none";

            video.play().catch(() => {});
        }

        function hoverPreviewStart() {
            if (window.innerWidth <= 768) return;
            if (card.classList.contains("playing")) return;

            video.muted = true;
            video.controls = false;

            if (poster) poster.style.display = "none";
            //if (btn) btn.style.display = "none";

            video.play().catch(() => {});
        }

        function hoverPreviewStop() {
            if (window.innerWidth <= 768) return;
            if (card.classList.contains("playing")) return;

            video.pause();
            video.currentTime = 0;

            if (poster) poster.style.display = "";
            if (btn) btn.style.display = "";
        }

        if (btn) {
            btn.addEventListener("click", function (e) {
                e.preventDefault();
                playFullVideo();
            });
        }

        if (poster) {
            poster.addEventListener("click", function () {
                playFullVideo();
            });
        }

        card.addEventListener("mouseenter", hoverPreviewStart);
        card.addEventListener("mouseleave", hoverPreviewStop);

        video.addEventListener("ended", function () {
            if (card.classList.contains("playing")) {
                card.classList.remove("playing");
                video.controls = false;
                video.muted = true;
                video.currentTime = 0;

                if (poster) poster.style.display = "";
                if (btn) btn.style.display = "";
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector(".js-video-slider");
    if (!slider || typeof $ === "undefined" || !$.fn.slick) return;

    function initVideoSlider() {

        const prevArrow = `
            <svg xmlns="http://www.w3.org/2000/svg" class="slick-prev" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <circle cx="14" cy="14.0001" r="14" transform="rotate(90 14 14.0001)" fill="#A25157"/>
                <path d="M13.4032 13.5012L15.9982 16.2549L15.2962 17.0001L12 13.5012L15.298 10.0001L16 10.7452L13.4032 13.5012Z" fill="white"/>
            </svg>
        `;

        const nextArrow = `
            <svg xmlns="http://www.w3.org/2000/svg" class="slick-next" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <circle cx="14" cy="14" r="14" transform="rotate(-90 14 14)" fill="#A25157"/>
                <path d="M14.5968 14.4988L12.0018 11.7451L12.7038 11L16 14.4988L12.702 18L12 17.2549L14.5968 14.4988Z" fill="white"/>
            </svg>
        `;

        if (window.innerWidth <= 768) {
            if (!$(slider).hasClass("slick-initialized")) {
                $(slider).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    //centerPadding: "60px",
                    arrows: true,
                    dots: false,
                    adaptiveHeight: false,
                    prevArrow: prevArrow,
                    nextArrow: nextArrow
                });
            }
        } else {
            if ($(slider).hasClass("slick-initialized")) {
                $(slider).slick("unslick");
            }
        }
    }

    initVideoSlider();
    window.addEventListener("resize", initVideoSlider);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
